// import {
//   NewspaperIcon,
//   LibraryIcon,
//   BookOpenIcon,
//   UserIcon,
//   UserGroupIcon,
//   VideoCameraIcon,
//   ShoppingBagIcon,
// } from '@heroicons/react/outline';

export const baseRoute = '/april';

type NavigationItem = {
  name: string;
  to: string;
  // icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
};
export const navigation: NavigationItem[] = [
  // { name: 'TOP', to: baseRoute, icon: HomeIcon },
  { name: 'NEWS', to: `${baseRoute}/news` },
  { name: 'STORY', to: `${baseRoute}/story` },
  { name: 'CHARACTER', to: `${baseRoute}/character` },
  { name: 'STAFF/CAST', to: `${baseRoute}/staff` },
  { name: 'BOOK', to: `${baseRoute}/book` },
  { name: 'MOVIE', to: `${baseRoute}/movie` },
  { name: 'GOODS', to: `${baseRoute}/goods` },
].filter(Boolean);
